import { ConfigService } from '@axo/config/ConfigService';
import { reloadData } from '@axo/form/data-access/backend-sync';
import { Broker } from '@axo/shared/data-access/types/broker';
import { useMemo } from 'react';

export const useBroker = () => {
  const broker = useMemo(() => {
    // TODO: replace with global app state store
    // Loads Broker from active application
    if (reloadData.get()?.broker) {
      return Number(reloadData.get()?.broker);
    }

    // Pre Form workaround
    // Before having an active application fallback solution
    const brand = ConfigService.get('global').brand;

    const zmartaBrokers: Array<typeof brand> = [
      'zmarta.se',
      'zmarta.no',
      'zmarta.fi',
      'freedomrahoitus.fi',
      'freedomfinance.se',
      'centum.no',
    ];

    if (zmartaBrokers.includes(brand)) return Broker.Zmarta;

    return Broker.Axo;
  }, []);

  return broker as Broker;
};
